<template>
  <el-card class="box-card" :class="getStatusCss(transaction.status)">
    <div slot="header" class="clearfix">
      <el-row :gutter="20" style="font-size: 1.3rem;">
        <el-col :span="12" :offset="0"
          ><i class="el-icon-collection-tag"></i>{{ transaction._id }}</el-col
        >
        <el-col :span="12" :offset="0">
          <transition name="el-fade-in" mode="out-in">
            <div
              :key="transaction.status"
              style="display: flex; justify-content: start; align-items: center; "
            >
              <div>
                <el-button
                  :icon="getStatusIcon(transaction.status)['icon']"
                  :type="getStatusIcon(transaction.status)['type']"
                  size="mini"
                  disabled
                  circle
                ></el-button>
              </div>
              <div
                style="text-overflow: ellipsis; width: 100%; overflow: hidden; white-space: nowrap;"
              >
                {{ getStatusText(transaction.status) }}
              </div>
            </div>
          </transition>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <i class="el-icon-date"></i>
          {{ $dayjs(transaction.date).format("DD.MM.YYYY") }}
          <i class="el-icon-watch"></i>
          {{ $dayjs(transaction.date).format("HH:mm:ss") }}
        </el-col>
        <el-col :span="12" :offset="0">
          <i class="el-icon-link"></i>
          {{ transaction.ip !== "null" ? transaction.ip : "--" }}
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :offset="0">
          <i class="el-icon-upload"></i>
          {{ (transaction.trans.source || "catbit").toUpperCase() }}
        </el-col>
        <el-col :span="12" :offset="0">
          <i class="el-icon-s-order"></i>
          <span v-if="transaction.ledgerExchangeId">
            <a
              href="#"
              @click.prevent="
                $router.push({
                  name: 'LedgerEdit',
                  params: { id: transaction.ledgerExchangeId }
                })
              "
            >
              {{ transaction.ledgerExchangeId }}
            </a>
          </span>
          <span
            v-else-if="transaction.status === 2 || transaction.status === 106"
          >
            <a
              href="#"
              @click.prevent="
                $router.push({
                  name: 'LedgerAddByTransactionId',
                  params: { transactionId: transaction._id }
                })
              "
            >
              Создать операцию в учете
            </a>
          </span>
        </el-col>
      </el-row>
    </div>
    <div>
      <div
        style="display: grid; grid-template-columns: 1fr auto 1fr; padding-bottom: 0.5rem;"
      >
        <div>
          <div
            style="display: flex; justify-content: end; align-items: center;"
          >
            <div>
              <div
                :style="{
                  width: '3rem',
                  height: '3rem',
                  'background-image': `url(http://localhost:3000/uploads/valutes/${transaction.give.valute.image})`,
                  'background-size': 'contain',
                  'background-repeat': 'no-repeat'
                }"
              >
                <i
                  style="display:none;font-size: 2rem;"
                  class="el-icon-bottom-left"
                ></i>
              </div>
            </div>
            <div>
              <span style="font-size: 1.5rem;"
                >{{
                  transaction.give.forms.find(f => f.key === "count")["value"]
                }}
              </span>
              <span style="font-size: 1.2rem;">
                {{ transaction.give.valute.key }}</span
              >
            </div>
          </div>
          <div class="inforow">
            <div>
              Валюта
            </div>
            <div>
              {{ transaction.give.valute ? transaction.give.valute.title : "" }}
            </div>
          </div>
          <div class="inforow">
            <div>
              Курс обмена
            </div>
            <div>
              {{
                (
                  transaction.give.forms.find(f => f.key === "count")["value"] /
                  transaction.get.forms.find(f => f.key === "result")["value"]
                ).toFixed(5)
              }}
              {{ transaction.give.valute.key }}/{{ transaction.get.valute.key }}
            </div>
          </div>
          <div class="inforow">
            <div>
              Курс биржевой
            </div>
            <div>
              {{ transaction.give.valute.course.toFixed(2) }} RUB за 1
              {{ transaction.give.valute.key }}
            </div>
          </div>
          <div class="inforow">
            <div>
              Курс наш
            </div>
            <div>
              {{
                (
                  transaction.give.valute.course *
                  +transaction.give.valute.percentGive
                ).toFixed(2)
              }}
              RUB за 1
              {{ transaction.give.valute.key }}
            </div>
          </div>
          <div class="inforow">
            <div>
              Наша комиссия
            </div>
            <div>
              {{
                (100 - +transaction.give.valute.percentGive * 100).toFixed(2)
              }}%
            </div>
          </div>
          <div class="inforow">
            <div>
              Реквизиты:
            </div>
            <div>
              <div
                v-if="
                  transaction.give.valute.invoiceCard ||
                    transaction.give.valute.invoiceQw ||
                    transaction.give.valute.invoiceYou
                "
              >
                <div>
                  <a
                    target="_blank"
                    :href="transaction.trans.url ? transaction.trans.url : '#'"
                    >{{
                      transaction.give.valute.invoiceCard
                        ? "Инвойс Карта"
                        : transaction.give.valute.invoiceQw
                        ? "Инвойс Qiwi"
                        : transaction.give.valute.invoiceYou
                        ? "Инвойс ЮMoney"
                        : "Неизвестный инвойс"
                    }}</a
                  >
                </div>
              </div>
              <div
                v-else-if="
                  transaction.trans.wbDepositStatus &&
                    transaction.trans.wbDepositStatus.account
                "
              >
                <div>
                  <div v-if="transaction.trans.wbDepositStatus.account.address">
                    <b>Сгенерированный кошелек WB:</b>
                    {{ transaction.trans.wbDepositStatus.account.address }}
                  </div>
                  <div v-if="transaction.trans.wbDepositStatus.account.memo">
                    <b>MEMO WB:</b>
                    {{ transaction.trans.wbDepositStatus.account.memo }}
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-for="(form, index) in transaction.give.wallet.forms"
                  :key="index"
                  style="overflow-wrap:anywhere;"
                >
                  {{ form ? form.title : "Нет информации" }} -
                  {{ form ? form.description : "Нет информации" }}
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="transaction.give.forms.filter(f => f.key !== 'count').length"
          >
            <div
              v-for="form in transaction.give.forms.filter(
                f => f.key !== 'count'
              )"
              class="inforow"
              :key="form.key"
            >
              <div>
                {{ form ? form.title : "" }}
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ form.value }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.paymentId"
            class="wallet-form-additional-info"
          >
            <div>
              Поступление средств контролируется автоматически
            </div>
            <div v-if="transaction.trans.vanilaDepositStatus" class="inforow">
              <div>
                Ожидаемое кол-во
              </div>
              <div>
                {{ transaction.trans.vanilaDepositStatus.amount }}
              </div>
            </div>
            <div v-if="transaction.trans.vanilaDepositStatus" class="inforow">
              <div>
                Поступившее кол-во
              </div>
              <div>
                {{ transaction.trans.vanilaDepositStatus.payment_amount }}
              </div>
            </div>
          </div>

          <div
            v-if="
              transaction.trans.wbDepositStatus &&
                transaction.trans.wbDepositStatus.account
            "
            class="wallet-form-additional-info"
          >
            <div>
              Поступление средств на WB контролируется автоматически
            </div>
            <div
              v-if="transaction.trans.wbDepositStatus.account.address"
              class="inforow"
            >
              <div>Сгенерированный кошелек WB:</div>
              <div>
                {{ transaction.trans.wbDepositStatus.account.address }}
              </div>
            </div>
            <div
              v-if="transaction.trans.wbDepositStatus.account.memo"
              class="inforow"
            >
              <div>MEMO WB:</div>
              <div>
                {{ transaction.trans.wbDepositStatus.account.memo }}
              </div>
            </div>
            <div
              v-if="
                transaction.trans.wbDepositResult &&
                  transaction.trans.wbDepositResult.records &&
                  transaction.trans.wbDepositResult.records[0]
              "
            >
              <div class="inforow">
                <div>Статус</div>
                <div>
                  {{
                    getWBDepositStatus(
                      transaction.trans.wbDepositResult.records[0].status
                    )["text"]
                  }}
                </div>
              </div>
              <div class="inforow">
                <div>Сумма</div>
                <div>
                  {{ transaction.trans.wbDepositResult.records[0].amount }}
                  {{ transaction.trans.wbDepositResult.records[0].ticker }}
                </div>
              </div>
              <div
                v-if="
                  transaction.trans.wbDepositResult.records[0].transactionHash
                "
                class="inforow"
              >
                <div>Хэш транзакции</div>
                <div style="overflow-wrap:anywhere;">
                  {{
                    transaction.trans.wbDepositResult.records[0].transactionHash
                  }}
                </div>
              </div>
              <div
                v-if="
                  transaction.trans.wbDepositResult.records[0].confirmations
                "
                class="inforow"
              >
                <div>Подтверждения сети</div>
                <div>
                  {{
                    transaction.trans.wbDepositResult.records[0].confirmations
                      .actual
                  }}
                  из
                  {{
                    transaction.trans.wbDepositResult.records[0].confirmations
                      .required
                  }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="transaction.trans.ccard">
            <div class="inforow">
              <div>
                Средства должны поступить на карту
              </div>
              <div>
                {{ transaction.trans.ccard }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <div>
            <i style="font-size: 3rem;" class="el-icon-right"></i>
          </div>
        </div>

        <div>
          <div
            style="display: flex; justify-content: start; align-items: center;"
          >
            <div>
              <span style="font-size: 1.5rem;">
                {{
                  transaction.get.forms.find(f => f.key === "result")["value"]
                }}</span
              ><span style="font-size: 1.2rem;">
                {{ transaction.get.valute.key }}</span
              >
            </div>
            <div>
              <div
                :style="{
                  width: '3rem',
                  height: '3rem',
                  'background-image': `url(http://localhost:3000/uploads/valutes/${transaction.get.valute.image})`,
                  'background-size': 'contain',
                  'background-repeat': 'no-repeat'
                }"
              >
                <i
                  style="display:none;font-size: 2rem;"
                  class="el-icon-top-right"
                ></i>
              </div>
            </div>
          </div>
          <div class="inforow reversed">
            <div>
              Валюта
            </div>
            <div>
              {{ transaction.get.valute ? transaction.get.valute.title : "" }}
            </div>
          </div>
          <div class="inforow reversed">
            <div>
              Курс обмена
            </div>
            <div>
              {{
                (
                  transaction.get.forms.find(f => f.key === "result")["value"] /
                  transaction.give.forms.find(f => f.key === "count")["value"]
                ).toFixed(5)
              }}
              {{ transaction.get.valute.key }}/{{ transaction.give.valute.key }}
            </div>
          </div>
          <div class="inforow reversed">
            <div>
              Курс биржевой
            </div>
            <div>
              {{ transaction.get.valute.course.toFixed(2) }} RUB за 1
              {{ transaction.get.valute.key }}
            </div>
          </div>
          <div class="inforow reversed">
            <div>
              Курс наш
            </div>
            <div>
              {{
                (
                  transaction.get.valute.course *
                  +transaction.get.valute.percentGet
                ).toFixed(2)
              }}
              RUB за 1
              {{ transaction.get.valute.key }}
            </div>
          </div>
          <div class="inforow reversed">
            <div>
              Наша комиссия
            </div>
            <div>
              {{
                (100 - +transaction.get.valute.percentGive * 100).toFixed(2)
              }}%
            </div>
          </div>
          <div
            v-if="transaction.get.forms.filter(f => f.key !== 'result').length"
          >
            <div
              v-for="form in transaction.get.forms.filter(
                f => f.key !== 'result'
              )"
              class="inforow reversed"
              :key="form.key"
            >
              <div>
                {{ form ? form.title : "" }}
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ form.value }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.wbConvertStatus"
            class="wallet-form-additional-info"
          >
            <div>
              Произведена автоматическая конвертация на WB
            </div>
            <div class="inforow reversed">
              <div>
                Детали
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  Куплено {{ transaction.trans.wbConvertStatus.amount }}
                  {{ transaction.trans.wbConvertStatus.market.split("_")[0] }}
                  за
                  {{ transaction.trans.wbConvertStatus.dealMoney }}
                  {{ transaction.trans.wbConvertStatus.market.split("_")[1] }}
                  (плюс комиссия
                  {{ transaction.trans.wbConvertStatus.dealFee }}
                  {{ transaction.trans.wbConvertStatus.market.split("_")[1] }})
                </div>
              </div>
            </div>
            <div class="inforow reversed">
              <div>
                ID ордера
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbConvertStatus.orderId }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.wbConvertError"
            class="wb-withdraw-error"
          >
            <div>
              Произошла ошибка автоматической конвертации на WB!
            </div>
            <div
              v-if="transaction.trans.wbConvertError.code !== undefined"
              class="inforow reversed"
            >
              <div>
                Сообщение
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbConvertError.message }}
                </div>
              </div>
            </div>
            <div
              v-for="error in Object.entries(
                transaction.trans.wbConvertError.errors || {}
              )"
              class="inforow reversed"
              :key="error[0]"
            >
              <div>
                {{ error[0] }}
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ error[1].join(" ") }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.wbTransferStatus"
            class="wallet-form-additional-info"
          >
            <div>
              Произведен перевод средств между балансами
            </div>
            <div class="inforow reversed">
              <div>
                Количество
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbTransferStatus.amount }}
                  {{ transaction.trans.wbTransferStatus.ticker }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.wbTransferError"
            class="wb-withdraw-error"
          >
            <div>
              Произошла ошибка при переводе средств между балансами!
            </div>
            <div
              v-if="transaction.trans.wbTransferError.code !== undefined"
              class="inforow reversed"
            >
              <div>
                Сообщение
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbTransferError.message }}
                </div>
              </div>
            </div>
            <div
              v-for="error in Object.entries(
                transaction.trans.wbTransferError.errors || {}
              )"
              class="inforow reversed"
              :key="error[0]"
            >
              <div>
                {{ error[0] }}
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ error[1].join(" ") }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              transaction.trans.wbWithdrawStatus &&
                transaction.trans.wbWithdrawStatus.uniqueId
            "
            class="wallet-form-additional-info"
          >
            <div>
              Отправка средств осуществляется автоматически
            </div>
            <div
              v-if="transaction.trans.wbWithdrawStatus.amount"
              class="inforow reversed"
            >
              <div>
                Сумма к отправке
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbWithdrawStatus.amount }}
                </div>
              </div>
            </div>
            <div
              v-if="transaction.trans.wbWithdrawStatus.status"
              class="inforow reversed"
            >
              <div>
                Статус
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{
                    getWBStatus(transaction.trans.wbWithdrawStatus.status)[
                      "name"
                    ]["ru"]
                  }}
                </div>
              </div>
            </div>
            <div
              v-if="transaction.trans.wbWithdrawStatus.transactionHash"
              class="inforow reversed"
            >
              <div>
                Хэш транзакции
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  <a
                    target="_blank"
                    :href="getHashCheckUrl(transaction.trans.wbWithdrawStatus)"
                  >
                    {{ transaction.trans.wbWithdrawStatus.transactionHash }}
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="transaction.trans.wbWithdrawError"
            class="wb-withdraw-error"
          >
            <div>
              Произошла ошибка при создании автоматического вывода на WB!
            </div>
            <div
              v-if="transaction.trans.wbWithdrawError.code !== undefined"
              class="inforow reversed"
            >
              <div>
                Сообщение
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ transaction.trans.wbWithdrawError.message }}
                </div>
              </div>
            </div>
            <div
              v-for="error in Object.entries(
                transaction.trans.wbWithdrawError.errors || {}
              )"
              class="inforow reversed"
              :key="error[0]"
            >
              <div>
                {{ error[0] }}
              </div>
              <div>
                <div style="overflow-wrap:anywhere;">
                  {{ error[1].join(" ") }}
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              [3, 4].includes(+transaction.status) &&
                transaction.trans.wbWithdrawStatus
            "
            class="wb-withdraw-error"
          >
            <div>
              При автоматической отправке средств произошел сбой! Необходимо
              проверить данную транзакцию вручную!
            </div>
          </div>
        </div>
      </div>

      <div class="verification-image" v-if="+transaction.status === 6">
        <el-image
          style="width: 200px; height: 200px"
          :src="transaction.verificationImage"
          :preview-src-list="[transaction.verificationImage]"
        >
          <div slot="placeholder" class="image-slot">
            Загрузка<span class="dot">...</span>
          </div>
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <!-- <img :src="transaction.verificationImage" alt="" /> -->
      </div>
    </div>

    <slot></slot>
  </el-card>
</template>

<script>
import { getWhitebitWithdrawStatus, getHashCheckUrl } from "./helpers";
export default {
  name: "OrderTransactionNew",
  props: {
    transaction: {
      type: Object
    }
  },
  methods: {
    getHashCheckUrl,

    getStatusText(status) {
      switch (+status) {
        case 0:
          return "В ожидании средств";
        case 1:
          return "В обработке";
        case 2:
          return "Подтверждено";
        case 3:
          return "Отклонено";
        case 4:
          return "Отменено";
        case 5:
          return "В ожидании фото для верификации";
        case 6:
          return "Верификация";
        case 106:
          return "Возобновлен";
      }
    },

    getStatusCss(status) {
      switch (+status) {
        case 0:
        case 1:
          return { orange: true };
        case 2:
        case 106:
          return { green: true };
        case 3:
        case 4:
          return { red: true };
        case 5:
        case 6:
          return { gray: true };
      }
    },

    getWBDepositStatus(status) {
      const statuses = [
        { id: 3, originalText: "Successfull", text: "Успешно" },
        { id: 7, originalText: "Successfull", text: "Успешно" },
        { id: 4, originalText: "Canceled", text: "Отменено" },
        { id: 9, originalText: "Canceled", text: "Отменено" },
        {
          id: 5,
          originalText: "Unconfirmed by user",
          text: "Неподтверждено пользователем"
        },
        { id: 22, originalText: "Uncredited", text: "Неоплачено" },
        { id: 15, originalText: "Pending", text: "В ожидании" }
      ];
      const unknownStatus = {
        id: 0,
        originalText: "Unknown",
        text: "Неизвестно"
      };
      return statuses.find(s => s.id === status) || unknownStatus;
    },

    getStatusIcon(status) {
      switch (+status) {
        case 0:
        case 1:
          return { icon: "el-icon-warning", type: "warning", color: "#E6A23C" };
        case 2:
        case 106:
          return { icon: "el-icon-success", type: "success", color: "#67C23A" };
        case 3:
        case 4:
          return { icon: "el-icon-error", type: "danger", color: "#F56C6C" };
        case 5:
        case 6:
          return { icon: "el-icon-question", type: "info", color: "#909399" };
      }
    },
    getWBStatus(wbstatus) {
      return getWhitebitWithdrawStatus(wbstatus);
    }
  }
};
</script>

<style scoped>
.box-card {
  margin-bottom: 10px;
}
.green {
  border-left: 10px solid #67c23a;
}
.orange {
  border-left: 10px solid #e6a23c;
}
.red {
  border-left: 10px solid #f56c6c;
}

.gray {
  border-left: 10px solid #909399;
}

.content {
  overflow: hidden;
}

.block-left,
.block-right {
  float: left;
  padding: 0 5px 10px 5px;
  width: calc(50% - 11px);
}

.block-left {
  border-right: 1px solid #d9d9d9;
}

.buttons {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
}

.buttons > button {
  width: 49%;
  display: inline-block;
  cursor: pointer;
}

.buttons > button.ok {
  background-color: green;
  color: #ffffff;
}

.buttons > button.cancel {
  background-color: #f56c6c;
  color: #ffffff;
}

.verification-image {
  max-width: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
  /* border: 1px solid #aaa; */
}
.verification-image img {
  display: block;
  width: 100%;
  height: auto;
}
.inforow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.1rem;
  border-bottom: 1px dotted #cccccc;
}
.inforow.reversed {
  flex-direction: row-reverse;
}
.inforow > div:nth-child(1) {
  font-weight: 600;
}
.inforow > div:nth-child(2) {
  max-width: 70%;
  font-weight: 200;
}
.inforow > div:nth-child(2) a,
a:visited {
  color: inherit;
}
.wallet-form-additional-info {
  font-size: 1rem;
  color: #409eff;
  font-weight: 600;
  padding-top: 1rem;
}
.wallet-form-additional-info > div:nth-child(1) {
  text-align: center;
  padding-bottom: 0.5rem;
}
.wb-withdraw-error {
  font-size: 1rem;
  color: #f56c6c;
  font-weight: 600;
  padding-top: 1rem;
}
.wb-withdraw-error > div:nth-child(1) {
  text-align: center;
  padding-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/OrderTransactionNew.vue